class OPBCreateNewPage {

    constructor() {
        this.$useTemplateBtn = null;
        this.useTemplateConfirm = null;
        this.$previewTemplateBtn = null;
        this.previewTemplateConfirm = null;
        this.$viewCollectionBtn = null;
        this.viewCollectionConfirm = null;

        this['jQueryInit']();
    }

    /**
     * jQuery initialization
     */
    ['jQueryInit']() {
        let _this = this;
        let $ = jQuery;

        $(document).ready(() => {
            _this.$useTemplateBtn = $('.opb-use-template-btn');
            _this.$previewTemplateBtn = $('.opb-preview-template-btn');
            _this.$viewCollectionBtn = $('.opb-view-collection-btn');

            _this['appInit']($);
        });
    }

    /**
     * Functionality after $ is ready
     *
     * @param {jQuery} $
     */
    ['appInit']($) {
        let _this = this;

        _this['newPageTemplate']($);
        _this['previewPageTemplate']($);
        _this['viewCollection']($);
    }

    /**
     * Open dialog with form that creates new page
     *
     * @param {jQuery} $
     */
    ['newPageTemplate']($) {
        let _this = this;

        _this.$useTemplateBtn.click((e) => {
            _this['useTemplateClick'](e);
        });
    }

    /**
     * Opens dialog when click on Use Template Button
     *
     * @param e
     */
    ['useTemplateClick'](e) {
        let _this = this;

        e.preventDefault();

        let $btn = $(e.currentTarget);
        let $templateList = $btn.closest('.opb-template-list');
        let $templateListItem = $btn.closest('.opb-template-list-item');

        let dialogOptions = window.OP3General.dialogOptions;
        let link = $btn.attr('href');
        let nonceValue = $templateList.find('#nonce-create-new-page').val();
        let templateUid = $templateListItem.data('template-uid');

        _this.useTemplateConfirm = $.dialog(Object.assign(dialogOptions, {
            theme: 'optimizepress,optimizepress-mini',
            title: 'Create New OptimizePress Page',
            content: () => {
                return _this.getCreateNewPageForm(link, nonceValue, templateUid, 'Page Title', 'Enter Page Title', 'Create Page');
            }
        }));
    }

    /**
     * Open dialog with form that creates new page
     *
     * @param {jQuery} $
     */
    ['previewPageTemplate']($) {
        let _this = this;

        _this.$previewTemplateBtn.click((e) => {
            _this['previewTemplateClick'](e);
        });
    }

    /**
     * Opens dialog when click on Preview Template Button
     *
     * @param e
     */
    ['previewTemplateClick'](e) {
        let _this = this;

        e.preventDefault();

        let $btn = $(e.currentTarget);
        let $templateListItem = $btn.closest('.opb-template-list-item');

        let dialogOptions = window.OP3General.dialogOptions;
        let templateName = $templateListItem.find('h4').text();
        let bigImage = $templateListItem.data('big-image');

        _this.previewTemplateConfirm = $.dialog(Object.assign(dialogOptions, {
            title: templateName,
            content: () => {
                return `<img src="${bigImage}">`;
            }
        }));
    }

    /**
     * Open dialog with form that creates new page
     *
     * @param {jQuery} $
     */
    ['viewCollection']($) {
        let _this = this;

        _this.$viewCollectionBtn
            .click((e) => {
                e.preventDefault();

                let $btn = $(e.currentTarget);

                let dialogOptions = window.OP3General.dialogOptions;

                _this.viewCollectionConfirm = $.dialog(Object.assign(dialogOptions, {
                    title: 'Collection Name',
                    content: () => {
                        return `<div class="opb-template-list d-flex flex-wrap justify-content-center" style="width: 100%; margin-left: 0;"> <input type="hidden" id="nonce-create-new-page" name="nonce-create-new-page" value="afb9a914ef"><input type="hidden" name="_wp_http_referer" value="/wp-admin/admin.php?page=op-builder-create"> <div class="opb-template-list-item" data-template-uid="opdb-5b45b332dd374" data-big-image="https://op3-sl.optimizehub.com/storage/media/108/conversions/PRICING-TABLES-small-large.jpg"> <div class="op3-white-box"> <div class="opb-template-preview op3-moving-image" data-transform-y="61"> <img src="https://op3-sl.optimizehub.com/storage/media/108/conversions/PRICING-TABLES-small-thumb.jpg" alt="[ELEMENT STYLES] Pricing Tables" style="transition: transform 0.305s ease-in-out 0s;"> </div><div class="opb-inner"> <h4>[ELEMENT STYLES] Pricing Tables</h4> <p>Landing pages</p><div class="opb-hover"> <a class="opb-preview-template-btn op3-button op3-transparent" href="">Preview Template<i class="op3-iconFont op3-zoom-plus-icon"></i></a> <a class="opb-use-template-btn op3-button" href="http://funnelbuilder.local/wp-admin/admin.php">Use This Template</a> </div></div></div></div><div class="opb-template-list-item" data-template-uid="opdb-5b190db38275e" data-big-image="https://op3-sl.optimizehub.com/storage/media/104/conversions/preview-90dy-large.jpg"> <div class="op3-white-box"> <div class="opb-template-preview op3-moving-image" data-transform-y="61"> <img src="https://op3-sl.optimizehub.com/storage/media/104/conversions/preview-90dy-thumb.jpg" alt="90 Day Year" style="transition: transform 0.3s ease-in-out 0s;"> </div><div class="opb-inner"> <h4>90 Day Year</h4> <p>Landing pages</p><div class="opb-hover"> <a class="opb-preview-template-btn op3-button op3-transparent" href="">Preview Template<i class="op3-iconFont op3-zoom-plus-icon"></i></a> <a class="opb-use-template-btn op3-button" href="http://funnelbuilder.local/wp-admin/admin.php">Use This Template</a> </div></div></div></div><div class="opb-template-list-item" data-template-uid="opdb-5b51e1f88261e" data-big-image=""> <div class="op3-white-box"> <div class="opb-template-preview op3-moving-image"> </div><div class="opb-inner"> <h4>Broken block</h4> <p>Landing pages</p><div class="opb-hover"> <a class="opb-preview-template-btn op3-button op3-transparent" href="">Preview Template<i class="op3-iconFont op3-zoom-plus-icon"></i></a> <a class="opb-use-template-btn op3-button" href="http://funnelbuilder.local/wp-admin/admin.php">Use This Template</a> </div></div></div></div><div class="opb-template-list-item" data-template-uid="opdb-5b20c9caf30fe" data-big-image="https://op3-sl.optimizehub.com/storage/media/105/conversions/block-large.jpg"> <div class="op3-white-box"> <div class="opb-template-preview op3-moving-image" data-transform-y="61"> <img src="https://op3-sl.optimizehub.com/storage/media/105/conversions/block-thumb.jpg" alt="colors-test" style="transition: transform 0.305s ease-in-out 0s;"> </div><div class="opb-inner"> <h4>colors-test</h4> <p>Landing pages</p><div class="opb-hover"> <a class="opb-preview-template-btn op3-button op3-transparent" href="">Preview Template<i class="op3-iconFont op3-zoom-plus-icon"></i></a> <a class="opb-use-template-btn op3-button" href="http://funnelbuilder.local/wp-admin/admin.php">Use This Template</a> </div></div></div></div><div class="opb-template-list-item" data-template-uid="opdb-5b5f032bc5ab9" data-big-image="https://op3-sl.optimizehub.com/storage/media/155/conversions/screenshot-large.jpg"> <div class="op3-white-box"> <div class="opb-template-preview op3-moving-image" data-transform-y="61"> <img src="https://op3-sl.optimizehub.com/storage/media/155/conversions/screenshot-thumb.jpg" alt="NoPages Marketing Automation" style="transition: transform 0.305s ease-in-out 0s;"> </div><div class="opb-inner"> <h4>NoPages Marketing Automation</h4> <p>Landing pages</p><div class="opb-hover"> <a class="opb-preview-template-btn op3-button op3-transparent" href="">Preview Template<i class="op3-iconFont op3-zoom-plus-icon"></i></a> <a class="opb-use-template-btn op3-button" href="http://funnelbuilder.local/wp-admin/admin.php">Use This Template</a> </div></div></div></div><div class="opb-template-list-item" data-template-uid="opdb-5b091663a1918" data-big-image="https://op3-sl.optimizehub.com/storage/media/96/conversions/Breaking-Bad-Heisenberg-large.jpg"> <div class="op3-white-box"> <div class="opb-template-preview op3-moving-image" data-transform-y="61"> <img src="https://op3-sl.optimizehub.com/storage/media/96/conversions/Breaking-Bad-Heisenberg-thumb.jpg" alt="One eight" style="transition: transform 0.305s ease-in-out 0s;"> </div><div class="opb-inner"> <h4>One eight</h4> <p>Landing pages</p><div class="opb-hover"> <a class="opb-preview-template-btn op3-button op3-transparent" href="">Preview Template<i class="op3-iconFont op3-zoom-plus-icon"></i></a> <a class="opb-use-template-btn op3-button" href="http://funnelbuilder.local/wp-admin/admin.php">Use This Template</a> </div></div></div></div><div class="opb-template-list-item" data-template-uid="yoga" data-big-image="https://op3-sl.optimizehub.com/storage/media/618/conversions/PREVIEW-large.jpg"> <div class="op3-white-box"> <div class="opb-template-preview op3-moving-image" data-transform-y="61"> <img src="https://op3-sl.optimizehub.com/storage/media/618/conversions/PREVIEW-thumb.jpg" alt="YOGA" style="transition: transform 0.305s ease-in-out 0s;"> </div><div class="opb-inner"> <h4>YOGA</h4> <p>Landing pages</p><div class="opb-hover"> <a class="opb-preview-template-btn op3-button op3-transparent" href="">Preview Template<i class="op3-iconFont op3-zoom-plus-icon"></i></a> <a class="opb-use-template-btn op3-button" href="http://funnelbuilder.local/wp-admin/admin.php">Use This Template</a> </div></div></div></div><div class="opb-template-list-item" data-template-uid="opdb-5b45b4e09c6de" data-big-image="https://op3-sl.optimizehub.com/storage/media/109/conversions/PRICING-TABLES-small-large.jpg"> <div class="op3-white-box"> <div class="opb-template-preview op3-moving-image" data-transform-y="61"> <img src="https://op3-sl.optimizehub.com/storage/media/109/conversions/PRICING-TABLES-small-thumb.jpg" alt="Zvonko testing" style="transition: transform 0.305s ease-in-out 0s;"> </div><div class="opb-inner"> <h4>Zvonko testing</h4> <p>Landing pages</p><div class="opb-hover"> <a class="opb-preview-template-btn op3-button op3-transparent" href="">Preview Template<i class="op3-iconFont op3-zoom-plus-icon"></i></a> <a class="opb-use-template-btn op3-button" href="http://funnelbuilder.local/wp-admin/admin.php">Use This Template</a> </div></div></div></div><div class="opb-template-list-item" data-template-uid="opdb-5b8807797b90a" data-big-image="https://op3-sl.optimizehub.com/storage/media/211/conversions/Screenshot-2018-08-30-14.00.23-large.jpg"> <div class="op3-white-box"> <div class="opb-template-preview op3-moving-image" data-transform-y="61"> <img src="https://op3-sl.optimizehub.com/storage/media/211/conversions/Screenshot-2018-08-30-14.00.23-thumb.jpg" alt="Zvonko testing" style="transition: transform 0.305s ease-in-out 0s;"> </div><div class="opb-inner"> <h4>Zvonko testing</h4> <p>Landing pages</p><div class="opb-hover"> <a class="opb-preview-template-btn op3-button op3-transparent" href="">Preview Template<i class="op3-iconFont op3-zoom-plus-icon"></i></a> <a class="opb-use-template-btn op3-button" href="http://funnelbuilder.local/wp-admin/admin.php">Use This Template</a> </div></div></div></div></div>`;
                    },
                    onContentReady: (e, a, b) => {
                        let $content = _this.viewCollectionConfirm.$content;

                        $content.find('.opb-preview-template-btn')
                            .click((e) => {
                                _this['previewTemplateClick'](e);
                            })
                        ;

                        $content.find('.opb-use-template-btn')
                            .click((e) => {
                                _this.viewCollectionConfirm.close();
                                _this['useTemplateClick'](e);
                            })
                        ;
                    }
                }));
            })
        ;
    }

    /**
     * Form HTML that is submitted upon creating new OptimizePress page
     *
     * @todo Boris - Added nonce "nonce-create-new-page" that should be checked in backend file PagesController::store
     *
     * @param {string} adminUrl
     * @param {string} nonceValue
     * @param {string} templateUid
     * @param {string} fieldTitle
     * @param {string} fieldPlaceholder
     * @param {string} submitText
     * @return {string}
     */
    getCreateNewPageForm(adminUrl, nonceValue, templateUid, fieldTitle, fieldPlaceholder, submitText) {
        return `
            <form class="op3-form" method="post" action="${adminUrl}">
                <input type="hidden" id="nonce-create-new-page" name="nonce-create-new-page" value="${nonceValue}">
                <input type="hidden" name="action" value="op-builder-store-page">
                <input type="hidden" name="template_id" value="${templateUid}">
            
                <div>
                    <label for="opb-pageTitle">${fieldTitle}</label>
                    <input id="opb-pageTitle" type="text" name="title" value="" placeholder="${fieldPlaceholder}">
                </div>

                <button type="submit" class="op3-button">${submitText}</button>
            </form>
        `;
    }
}

export default OPBCreateNewPage;


// WEBPACK FOOTER //
// ./resources/assets/js/OP3Builder/Pages/OPBCreateNewPage.js